// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"918":"e4e61a72","966":"51aae275"}[chunkId] + ".css";
};